// extracted by mini-css-extract-plugin
export default {"author":"_c13428ba","authorName":"_12e9c13d","authorLogo":"_46bccfb1","expertLogo":"_5187230a","authorInfo":"_16b578b4"};